import { type QueryHookOptions, useQuery } from '@provision/graphql-client';
import { isNullish } from 'remeda';
import { GET_LANDING_PAGE_CONFIG_QUERY } from 'src/graphql/entities/landing-page-config/landing-page-config.operations';
import type {
  GetLandingPageConfigQueryData,
  GetLandingPageConfigQueryVariables,
} from 'src/graphql/entities/landing-page-config/landing-page-config.types';

type UseLandingPageConfigParams = {
  partnerId: number | null;
  brandId: string | null;
};

export const useLandingPageConfig = (
  { partnerId, brandId }: UseLandingPageConfigParams,
  options?: QueryHookOptions<
    GetLandingPageConfigQueryData,
    GetLandingPageConfigQueryVariables
  >,
) => {
  const shouldFetch = !isNullish(partnerId) && Boolean(brandId) && options?.skip !== true;

  const { data, loading, error, refetch } = useQuery<
    GetLandingPageConfigQueryData,
    GetLandingPageConfigQueryVariables
  >(GET_LANDING_PAGE_CONFIG_QUERY, {
    ...options,
    fetchPolicy: options?.fetchPolicy ?? 'no-cache',
    nextFetchPolicy: options?.nextFetchPolicy ?? 'no-cache',
    variables: {
      input: {
        partnerId: partnerId ?? 0,
        brandId: brandId ?? '',
      },
    },
    skip: !shouldFetch,
  });

  const config = data?.getBundledLandingPageConfig ?? null;

  return { config, loading, error, refetch };
};
